<template>
    <div>
        <h3 class="mt-3 mb-4 mk-masteragreement">Guarantors</h3>
        <hr />

        <div
            class="row m-2"
            style="border-bottom: 1px solid #efefef;"
            v-for="guarantor in guarantors"
            :key="guarantor.id"
        >
            <div class="col-10">
                <p><strong>First name</strong> {{guarantor.first_name}}</p>
                <p><strong>Last name</strong> {{guarantor.last_name}}</p>
                <p><strong>Phone</strong> {{guarantor.phone}}</p>
                <p><strong>Email</strong> {{guarantor.email}}</p>
                <p><strong>Postal Address</strong> {{guarantor.postal_address}}</p>
            </div>
            <div class="col-2">
                <p>
                    <strong>Created At: </strong>
                    {{
                        moment(
                            guarantor.created_at,
                            "YYYY-MM-DD HH:mm:ss"
                        ).format("DD/MM/YYYY HH:mma")
                    }}
                </p>
            </div>
          
        </div>
    </div>
</template>
<script>
export default {
    props: {
        business: {
            type: Object
        }
    },
    mounted() {
        this.guarantors = this.business.guarantors;
    },
    data() {
        return {
            guarantors: []
        };
    }
};
</script>
